package br.com.texeratx.boardgametimeapp.ui.screens.reset_password

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.getScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow

data class ResetPasswordScreen(val email: String = "") : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = getScreenModel<ResetPasswordViewModel>()
        val state by viewModel.state.collectAsState()

        LaunchedEffect(email) {
            viewModel.initEmail(email)
        }

        ResetPasswordUI(
            state = state,
            onEmailChange = viewModel::updateEmail,
            onCodeChange = viewModel::updateCode,
            onNewPasswordChange = viewModel::updateNewPassword,
            onConfirmPasswordChange = viewModel::updateConfirmPassword,
            onSubmitClick = { viewModel.submit(navigator) },
            onBack = { navigator.pop() }
        )
    }
}
